module.exports = __webpack_public_path__ + "img/eqli.7ed87cfe.svg";